import { Bot, Sparkles } from "lucide-react"
import {
  useGetAdvisorSessionsQuery,
  useGetAdvisorSessionQuery
} from "../../../../../../redux/queries"
import AdvisorSkeleton from "./advisor-skeleton"
import ConversationsTable from "./conversations-table"

interface Props {
  subscriptionId: string
  leadName: string
}

const EngagementAdvisorSection = ({ subscriptionId, leadName }: Props) => {
  const { data: sessionsPage, isLoading: isLoadingSessions } =
    useGetAdvisorSessionsQuery({ page: 1, limit: 100 })

  const session = sessionsPage?.conversations?.find(
    s => s.subscriptionId === subscriptionId
  )

  const { data: sessionDetail, isLoading: isLoadingDetail } =
    useGetAdvisorSessionQuery(session?._id ?? "", {
      skip: !session?._id
    })

  const isLoading = isLoadingSessions || (!!session && isLoadingDetail)
  const threads = sessionDetail?.threads ?? []

  if (isLoading) return <AdvisorSkeleton />

  if (!session) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
        <div className="relative w-14 h-14 flex items-center justify-center rounded-full bg-indigo-50">
          <Bot className="w-7 h-7 text-indigo-300" />
          <Sparkles className="w-6 h-6 text-indigo-300 absolute -top-1 -left-1" />
        </div>
        <p className="text-sm font-semibold text-neutral-600">
          No AI Advisor conversations yet
        </p>
        <p className="text-xs text-neutral-400 max-w-xs">
          When this lead interacts with the AI Advisor, their conversations will
          appear here.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {/* <InsightsCard leadName={leadName} session={session} /> */}
      <ConversationsTable
        threads={threads}
        leadName={leadName}
        sessionId={session._id}
      />
    </div>
  )
}

export default EngagementAdvisorSection
